import { useSession } from '../../../../../contexts/SessionContext'
import { useDirectDebitStatus } from '../../../../../contexts/session/DirectDebitContext'

import Button from '../../../../elements/direct-debit/Button'
import DDIcon from '../../../../icons/DDIcon'
import styles from './TerminalScreen.module.css'

// Spec §9 generic failure terminal ("Something went wrong"). Per the rule that every
// failure message must say whether money moved, the fixed reassurance copy always shows;
// the backend's own message (if any) is shown underneath rather than replacing it, so
// nothing the backend actually told us gets lost (the legacy FailedScreen.js only showed
// the backend message, with its own generic fallback - this keeps both).
const SomethingWentWrongScreen = () => {
  const { sessionData } = useSession()
  const { directDebitStatus, sessionReference, resetFlow } = useDirectDebitStatus()
  const redirectUrl = sessionData?.redirectUri
  const merchantName = sessionData?.merchantName || 'merchant'

  return (
    <div className={styles.body}>
      <span className={styles.iconCircle}>
        <DDIcon name='terminal-warning' />
      </span>
      <h1 className={styles.title}>Something went wrong</h1>
      <p className={styles.message}>It's not you. Your details are saved and nothing was charged.</p>
      {directDebitStatus.message && <p className={styles.message}>{directDebitStatus.message}</p>}
      {sessionReference && <p className={styles.reference}>Reference: {sessionReference}</p>}
      <div className={styles.actions}>
        <Button onClick={() => resetFlow()}>Try again</Button>
        <Button variant='link' onClick={() => redirectUrl && window.location.replace(redirectUrl)}>
          Back to {merchantName}
        </Button>
      </div>
    </div>
  )
}

export default SomethingWentWrongScreen
